export const MigrosCampaignSummerTheme = {
  name: 'Migros Campaign Summer Theme',
  themeId: 'migrosCampaignSummer',
  colors: {
    brand: {
      primary: {
        100: '#FF6600'
      },
      secondary: {
        100: '#B24700'
      },
      text: {
        100: '#333333'
      },
      textInverted: {
        100: '#FFFFFF'
      }
    }
  },
  fonts: {
    families: {
      text: '"Helvetica Now Display", "Helvetica", arial, sans-serif',
      heading: '"Helvetica Now Display", "Helvetica", arial, sans-serif',
      condensed: '"Helvetica Now Display", "Helvetica", arial, sans-serif'
    },
    weights: {
      semiBold: 800
    },
    sizes: {
      text: {
        xsmall: '16px'
      },
      heading: {
        medium: '28px'
      }
    }
  },
  borderRadiuses: {
    medium: '4px'
  }
};